import { render, staticRenderFns } from "./report-shedi.vue?vue&type=template&id=5f248962&scoped=true&"
import script from "./report-shedi.vue?vue&type=script&lang=ts&"
export * from "./report-shedi.vue?vue&type=script&lang=ts&"
import style0 from "./report-shedi.vue?vue&type=style&index=0&id=5f248962&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f248962",
  null
  
)

export default component.exports